import compute from 'components/Compute';

$(() => {
  if ($('#paper_form').length) {
    $('.choice input[type=radio]').on('change', function () {
      console.log('chosen_paper changed');
      window.prices.chosen_paper = $(this).data('paperTitle');
      window.prices.chosen_paper_id = $(this).val();
      compute();
    });

    $('select[name=quantity_papier]').on('change', function () {
      console.log('paper_qty changed');
      const v = $(this).val();
      window.prices.paper_qty = v;
      compute();
      if (v == '') {
        $('.hideIfNoQty').addClass('hidden');
        $('.showIfNoQty').removeClass('hidden');
      } else {
        $('.hideIfNoQty').removeClass('hidden');
        $('.showIfNoQty').addClass('hidden');
        $('.prix').each(function () {
          let priceTable = $(this).data('prices');
          $(this).find('span').text(priceTable[v].prix);
        });
      }
    });

    $('select[name=quantity_papier]').trigger('change');

    $('input[name="round_corner"]').on('change', function () {
      window.prices.round_corner = $(this).is(':checked') && $(this).val()==1;
      compute();
    });
  }
});
